import { CaseEntitiesCardView } from '@/components/case-report/CaseEntitiesCardView'
import { useAllData } from '@/hooks/use-case-queries'

interface CaseEntitiesCardProps {
  caseId: string
  /** Per-type cap for rows shown when a tab is selected. */
  perTypeLimit?: number
}

/**
 * Connected "Case entities" card. Pulls a single page of high-signal
 * entities (ranked by investigation_score) and feeds the pure
 * {@link CaseEntitiesCardView}, which groups + renders them.
 */
export function CaseEntitiesCard({ caseId, perTypeLimit = 12 }: CaseEntitiesCardProps) {
  const { data, isLoading } = useAllData(caseId, {
    skip: 0,
    limit: 200,
    sortField: 'investigation_score',
    sortDir: 'desc',
  })

  return (
    <CaseEntitiesCardView
      nodes={data?.nodes ?? []}
      total={data?.total ?? null}
      isLoading={isLoading}
      perTypeLimit={perTypeLimit}
    />
  )
}
